import { render, staticRenderFns } from "./SlotList.vue?vue&type=template&id=418f04ac&"
import script from "./SlotList.vue?vue&type=script&lang=js&"
export * from "./SlotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports